import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

export const Director = () => (
  <section className="relative border-y border-white/10 bg-[#162B63] py-24 sm:py-32" data-testid="director-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE }}
        className="mx-auto max-w-4xl text-center"
      >
        <Quote className="mx-auto h-10 w-10 text-[#FF5722]" />
          <blockquote className="font-display mx-auto mt-6 max-w-3xl text-2xl font-bold leading-snug tracking-tight text-slate-100 sm:text-3xl lg:text-4xl" data-testid="director-quote">
            "A prevenção de perdas não é apenas um custo operacional — é o gargalo invisível que corrói a
            lucratividade do varejo. Nossa missão é devolver esse dinheiro ao seu balanço."
          </blockquote>
          <div className="mt-8 flex items-center justify-center gap-4">
            <span className="h-px w-12 bg-[#FF5722]" />
            <div className="text-left">
              <p className="font-display text-base font-bold" data-testid="director-name">Jefferson de Assis Benedicto</p>
              <p className="font-tech mt-1 text-[11px] uppercase tracking-[0.2em] text-slate-400">
                Diretor · ResgateCar
              </p>
            </div>
            <span className="h-px w-12 bg-[#FF5722]" />
          </div>
        </motion.div>
    </div>
  </section>
);

export default Director;
